// extracted by mini-css-extract-plugin
export var downArrow = "_9p-0";
export var infoTooltipIcon = "_9p-3";
export var label = "_9p-1";
export var optionCard = "_9p-4";
export var upArrow = "_9p-2";